module.exports = __webpack_public_path__ + "static/media/Drag-Active.dd59325c.svg";